import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Grid from "components/common/Grid";
import { makeStyles } from "@mui/styles";
import LinkIcon from "@mui/icons-material/Link";
import CallIcon from "@mui/icons-material/Call";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { useHistory } from "react-router-dom";

const RequestDetails = ({ data }) => {
  const classes = useStyles();
  let history = useHistory();

  return (
    <>
      <Box className={classes.grandParent}>
        <Box sx={{ display: "flex" }}>
          <ArrowBackIcon
            sx={{
              fontSize: "20px",
              margin: "0px 0px 10px 0px",
              color: "#707070",
            }}
            onClick={() => history.goBack()}
          />
        </Box>
        <Box>
          <Box
            className={classes.headingBox}
            sx={{
              borderBottom: "1px solid #EBEBEB",
              color: "#707070",
            }}
          >
            <Text
              variant="h4"
              component="div"
              gutterBottom
              sx={{ color: "#1A1A1A", marginLeft: "14px" }}
            >
              Basic Details
            </Text>
          </Box>
          <Box className={classes.parentBox}>
            <Box className={classes.image}>
              <img
                src="https://www.w3schools.com/howto/img_avatar.png"
                alt="profilePic"
                width="50px"
                height="56px"
                style={{ borderRadius: "26px", marginLeft: "18px" }}
              />
            </Box>

            <Box className={classes.childBox}>
              <Box className={classes.subChildBox}>
                <Box>
                  <Text
                    className={classes.texthead}
                    variant="h"
                    component="div"
                    gutterBottom
                    sx={{
                      color: "#707070",
                      marginTop: "5px",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "5px",
                    }}
                  >
                    {data?.name}
                  </Text>
                </Box>
              </Box>

              <Box className={classes.textBox}>
                <Grid container rowSpacing={1} spacing={0}>
                  <Grid item xs={1} md={1} lg={1}>
                    <CallIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={5} md={4} lg={4}>
                    <Text
                      className={classes.texthead}
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "5px",
                      }}
                    >
                      {data?.mobile}
                    </Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <MailOutlineIcon sx={iconStyle}></MailOutlineIcon>
                      <Text
                        variant="a"
                        component="div"
                        gutterBottom
                        sx={{
                          letterSpacing: "0.28px",
                          color: "#707070",
                          opacity: "1",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {data?.email}
                      </Text>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box className={classes.textBox}>
                <Grid container rowSpacing={1} spacing={0}>
                  <Grid item xs={1} md={1} lg={1}>
                    <CalendarTodayOutlinedIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={5} md={4} lg={4}>
                    <Text
                      className={classes.texthead}
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "5px",
                      }}
                    >
                      {data?.date_of_birth}
                    </Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src="/images/Area.png"
                        alt="area"
                        style={{
                          marginTop: "6px",
                          width: "8%",
                          height: "5%",
                          marginLeft: "6px",
                        }}
                      />
                      <Text
                        variant="a"
                        component="div"
                        gutterBottom
                        sx={{
                          letterSpacing: "0.28px",
                          color: "#707070",
                          opacity: "1",
                          textAlign: "left",
                          marginTop: "5px",
                          marginLeft: "5px",
                        }}
                      >
                        {data?.area}
                      </Text>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
              <Box className={classes.textBox}>
                <Grid container rowSpacing={1} spacing={0}>
                  <Grid item xs={1} md={1} lg={1}>
                    <img
                      src="/images/PAN.png"
                      alt="area"
                      style={{
                        marginTop: "7px",
                        width: "52%",
                        height: "63%",
                        marginLeft: "6px",
                      }}
                    />
                  </Grid>

                  <Grid item xs={5} md={4} lg={4}>
                    <Text
                      className={classes.texthead}
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "5px",
                      }}
                    >
                      {data?.pan}
                    </Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <img
                        src="/images/GST.png"
                        alt="gst"
                        className={classes.gst_image}
                        style={{
                          marginTop: "6px",
                          width: "9%",
                          height: "0%",
                          marginLeft: "5px",
                        }}
                      />
                      <Text
                        variant="a"
                        component="div"
                        gutterBottom
                        sx={{
                          letterSpacing: "0.28px",
                          color: "#707070",
                          opacity: "1",
                          textAlign: "left",
                          marginTop: "5px",
                          marginLeft: "4px",
                        }}
                      >
                        {data?.gst_no}
                      </Text>
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              <Box
                sx={{
                  borderBottom: "1px solid #EBEBEB",
                  margin: "10px 10px 20px 5px",
                  color: "#707070",
                }}
              >
                <Text
                  variant="h4"
                  component="div"
                  gutterBottom
                  sx={{ color: "#1A1A1A", marginTop: "20px" }}
                >
                  Business details
                </Text>
              </Box>
              <Box className={classes.subChildBox}>
                <Box>
                  <Text
                    variant="h"
                    component="div"
                    gutterBottom
                    sx={{
                      color: "#707070",
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "5px",
                    }}
                  >
                    {data?.business_type}
                  </Text>
                </Box>
              </Box>

              <Box className={classes.textBox}>
                <Grid container rowSpacing={0} spacing={0}>
                  <Grid item xs={1} md={1} lg={1}>
                    <LinkIcon sx={iconStyle} />
                  </Grid>

                  <Grid item xs={11} md={11} lg={11}>
                    <Text
                      className={classes.texthead}
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        textDecoration: "none",
                        marginTop: "5px",
                        marginLeft: "0px",
                      }}
                    >
                      {data?.business_url}
                      <a
                        href={"/"}
                        target="_blank"
                        className={classes.webUrl} rel="noreferrer"
                      ></a>
                    </Text>
                  </Grid>
                </Grid>
                <Grid item xs={1} md={1} lg={1}>
                  <CallIcon sx={iconStyle} />
                </Grid>

                <Grid item xs={5} md={4} lg={4}>
                  <Text
                    className={classes.texthead}
                    variant="a"
                    component="div"
                    gutterBottom
                    sx={{
                      letterSpacing: "0.28px",
                      color: "#707070",
                      opacity: "1",
                      textAlign: "left",
                      marginTop: "5px",
                    }}
                  >
                    {data?.business_mobile}
                  </Text>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <MailOutlineIcon sx={iconStyle}></MailOutlineIcon>
                    <Text
                      variant="a"
                      component="div"
                      gutterBottom
                      sx={{
                        letterSpacing: "0.28px",
                        color: "#707070",
                        opacity: "1",
                        textAlign: "left",
                        marginTop: "5px",
                      }}
                    >
                      {data?.business_email}
                    </Text>
                  </Box>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  grandParent: {
    padding: "1rem",
    "@media (max-width:768px)": {
      padding: "0px",
    },
  },
  webUrl: {
    letterSpacing: "0.28px",
    color: "#707070",
    opacity: "1",
    textAlign: "left",
    textDecoration: "underline",
    marginTop: "5px",
  },
  parentBox: {
    flexDirection: "row",
    marginLeft: "30px",
    "@media (max-width:768px)": {
      flexDirection: "column",
    },
  },
  childBox: {
    margin: "0px 1rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media (max-width:768px)": {
      marginLeft: "-51px",
    },
  },
  subChildBox: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      display: "block",
      marginLeft: "5px",
    },
  },
  textBox: {
    display: "flex",
    height: "auto",
    color: "#474747",
    width: "50%",
    flexWrap: "wrap",

    "@media (max-width:768px)": {
      width: "100%",
    },
  },

  headingBox: {
    marginTop: "-30px",
    marginLeft: "30px",

    "@media (max-width:768px)": {
      marginLeft: "16px",
    },
  },
  image: {
    "@media (max-width:768px)": {
      marginLeft: "-46px",
    },
  },
  texthead: {
    "@media (max-width:768px)": {
      marginLeft: "10px",
    },
  },
  gst_image: {
    "@media (max-width:768px)": {
      marginTop: "12px",
    },
  },
}));

export default RequestDetails;

const iconStyle = { margin: "7px 5px 0px 5px", width: "20px", height: "20px" };
